module.exports = __webpack_public_path__ + "img/1479209694.40539908.jpg";